import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { FolderView, ListPending } from "../components/FolderView.tsx";
import { Icon } from "../components/Icon.tsx";
import { StatePanel } from "../components/StatePanel.tsx";
import ui from "../components/ui.module.css";
import { messageOf, nodesQuery } from "../lib/queries.ts";

export const Route = createFileRoute("/")({
  loader: ({ context }) => context.queryClient.ensureInfiniteQueryData(nodesQuery(null)),
  component: Files,
  pendingComponent: FilesPending,
  errorComponent: FilesError,
});

function Files() {
  useEffect(() => {
    document.title = "Files · Vault";
  }, []);

  return <FolderView folder={null} />;
}

function FilesPending() {
  return <ListPending title="Files" />;
}

function FilesError({ error, reset }: { error: unknown; reset: () => void }) {
  const router = useRouter();
  return (
    <StatePanel icon="alert" title="Files did not load" detail={messageOf(error)}>
      <button
        type="button"
        className={ui.button}
        onClick={() => {
          reset();
          void router.invalidate();
        }}
      >
        <Icon name="retry" />
        Try again
      </button>
    </StatePanel>
  );
}
